import { NASELJA } from '../lib/konstante';
import { prebrojiStatuse } from '../lib/evidencija';
import Ikona from './Ikona';
import StatusTocke from './StatusTocke';

export function Brojke({ zapisi, novo }) {
  const brojevi = prebrojiStatuse(zapisi);
  const kartice = [
    {
      naziv: novo ? 'Kućanstva u evidenciji' : 'Članovi u bilježnici',
      broj: brojevi.ukupno,
      ikona: 'kuca',
      opis: novo ? 'Novo stanje' : 'Povijesni popis',
      boja: 'tirkiz',
    },
    {
      naziv: 'Potvrđene pozicije',
      broj: brojevi.potvrdjeno,
      ikona: 'potvrda',
      opis: 'Provjereno od strane čovjeka',
      boja: 'zelena',
    },
    {
      naziv: 'Čekaju potvrdu',
      broj: brojevi.potvrda,
      ikona: 'sat',
      opis: 'Pozicije još nisu provjerene',
      boja: 'jantar',
    },
    {
      naziv: 'Bez pozicije',
      broj: brojevi.bez,
      ikona: 'lokacija',
      opis: 'Potrebno upisati koordinate',
      boja: 'siva',
    },
  ];
  return (
    <div className="brojke">
      {kartice.map((k) => (
        <article className="brojka-kartica" key={k.naziv}>
          <div>
            <span>{k.naziv}</span>
            <span className={`ikona-ploha ${k.boja}`}>
              <Ikona naziv={k.ikona} />
            </span>
          </div>
          <strong>{k.broj}</strong>
          <small>{k.opis}</small>
        </article>
      ))}
    </div>
  );
}

export default function Pregled({
  kucanstva,
  clanovi,
  naPrikaz,
  naOdabir,
  naNovo,
}) {
  const brojevi = prebrojiStatuse(kucanstva);
  const postotak = brojevi.ukupno
    ? Math.round((brojevi.potvrdjeno / brojevi.ukupno) * 100)
    : 0;
  const zaProvjeru = [
    ...kucanstva.filter((k) => k.stanje === 'nejasno'),
    ...kucanstva.filter(
      (k) => k.stanje !== 'nejasno' && k.status === 'predlozeno',
    ),
  ].slice(0, 4);
  return (
    <div className="pregled">
      {naNovo && (
        <div className="brzi-unos">
          <span>Popisuješ kućanstvo na terenu?</span>
          <button className="gumb" onClick={naNovo}>
            + Novo kućanstvo
          </button>
        </div>
      )}
      <section className="dobrodoslica">
        <div>
          <span className="nadnaslov">
            <i /> ZAJEDNIČKA BRIGA ZA NAŠ VODOVOD
          </span>
          <h2>
            Jasna evidencija.
            <br />
            Sigurnija opskrba.
          </h2>
          <p>
            Kućanstva, priključci i njihove lokacije.
            <br />
            Znanje o našem vodovodu na jednom mjestu.
          </p>
          <button
            className="gumb svijetli"
            onClick={() => naPrikaz('karta', 'novo')}
          >
            Otvori kartu <Ikona naziv="strelica" velicina={18} />
          </button>
        </div>
        <div className="crtez-podrucja" aria-hidden="true">
          <svg viewBox="0 0 430 250" fill="none">
            <path
              className="obris-podrucja"
              d="m62 42 74-24 43 25 72-18 80 38 44 56-23 64-65 41-51-17-78 24-59-45-51-8 14-63Z"
            />
            <path d="m23 133 73-24 55 16 57-44 84 12 101-30M89 251l37-64-17-58 34-67-7-44m42 232 23-61 47-18 5-80 54-66M30 44l72 33 81-8 58 47 65 18 112-11M52 203l90-30 39-29 75 21 93 37" />
            <path
              className="crtez-voda"
              d="m133 58 17 57 73 18 46 52m-46-52 66-52"
            />
            <circle cx="133" cy="58" r="10" />
            <circle cx="223" cy="133" r="10" />
            <circle cx="269" cy="185" r="10" />
            <text x="150" y="49">
              Hum Stubički
            </text>
            <text x="108" y="150">
              Jakšinec
            </text>
            <text x="287" y="199">
              Karivaroš
            </text>
          </svg>
          <span>TRI NASELJA. JEDNA ZAJEDNICA.</span>
        </div>
      </section>
      <div className="naslov-odjeljka">
        <div>
          <h2>Nova evidencija kućanstava</h2>
          <p>Trenutno prikupljeni podaci, odvojeni od stare bilježnice.</p>
        </div>
        <button
          className="tekst-gumb"
          onClick={() => naPrikaz('popis', 'novo')}
        >
          Sva kućanstva <Ikona naziv="strelica" velicina={17} />
        </button>
      </div>
      <Brojke zapisi={kucanstva} novo />
      <div className="mreza-pregleda">
        <section className="ploca naselja-ploca">
          <div className="naslov-ploce">
            <div>
              <h3>Evidencija po naseljima</h3>
              <p>Obuhvat novih i povijesnih zapisa</p>
            </div>
            <Ikona naziv="karta" />
          </div>
          <div className="legenda-naselja">
            <span>
              <i />
              Nova evidencija
            </span>
            <span>
              <i />
              Stara bilježnica
            </span>
          </div>
          {NASELJA.map((n) => {
            const novo = kucanstva.filter((k) => k.naselje === n.naziv).length;
            const staro = clanovi.filter((c) => c.naselje === n.naziv).length;
            const najvise = Math.max(clanovi.length, kucanstva.length, 1);
            return (
              <button
                className="redak-naselja"
                key={n.naziv}
                onClick={() => naPrikaz('popis', 'novo', { naselje: n.naziv })}
              >
                <span className="oznaka-naselja">{n.naziv[0]}</span>
                <span className="naselje-sadrzaj">
                  <strong>{n.naziv}</strong>
                  <span className="par-traka">
                    <i style={{ width: `${(novo / najvise) * 100}%` }} />
                    <i style={{ width: `${(staro / najvise) * 100}%` }} />
                  </span>
                </span>
                <span className="par-brojeva">
                  <b>{novo}</b>
                  <span>{staro}</span>
                </span>
                <Ikona naziv="desno" velicina={16} />
              </button>
            );
          })}
          <p className="napomena-ploce">
            Broj zapisa ne potvrđuje potpunost popisa. Evidencije se vode
            odvojeno.
          </p>
        </section>
        <section className="ploca provjere-ploca">
          <div className="naslov-ploce">
            <div>
              <h3>Sljedeće za provjeru</h3>
              <p>Male provjere za pouzdaniju evidenciju</p>
            </div>
            <span className="ikona-ploha jantar">
              <Ikona naziv="sat" velicina={18} />
            </span>
          </div>
          {zaProvjeru.length ? (
            zaProvjeru.map((k) => (
              <button
                className="redak-provjere"
                key={k.id}
                onClick={() => naOdabir(k.id)}
              >
                <span className="ikona-ploha siva">
                  <Ikona naziv="kuca" velicina={18} />
                </span>
                <span>
                  <strong>{k.adresa}</strong>
                  <small>
                    {k.stanje === 'nejasno'
                      ? 'Podaci o nositelju za provjeru'
                      : 'Provjeri položaj na ortofotu'}
                  </small>
                </span>
                <StatusTocke status={k.status} />
                <Ikona naziv="desno" velicina={15} />
              </button>
            ))
          ) : (
            <p className="prazna-provjera">
              {kucanstva.length
                ? 'Nema predloženih pozicija ni nejasnih zapisa. Kućanstva bez pozicije dostupna su u popisu.'
                : 'Nova evidencija još nema kućanstava.'}
            </p>
          )}
          <button
            className="podnozje-provjera"
            onClick={() => naPrikaz('popis', 'novo', { filter: 'potvrda' })}
          >
            Prikaži pozicije za potvrdu <Ikona naziv="strelica" velicina={16} />
          </button>
        </section>
      </div>
      <section className="ploca napredak-ploca">
        <span className="ikona-ploha tirkiz">
          <Ikona naziv="potvrda" />
        </span>
        <div>
          <h3>Korak po korak do pouzdane karte</h3>
          <p>
            {brojevi.potvrdjeno} od {brojevi.ukupno} kućanstava ima potvrđenu
            poziciju. Geokodirane točke čekaju ljudsku provjeru.
          </p>
        </div>
        <div className="napredak-mjerac">
          <strong>
            {postotak}
            <small>%</small>
          </strong>
          <div
            role="progressbar"
            aria-label="Potvrđene pozicije kućanstava"
            aria-valuenow={postotak}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <i style={{ width: `${postotak}%` }} />
          </div>
        </div>
      </section>
    </div>
  );
}
